import { Link } from "react-router-dom";

import type { Production } from "../api/types";
import { valeurListe } from "../utils/format";
import { OrigineBadge } from "./OrigineBadge";

export function ProductionCard({ production }: { production: Production }) {
  const disciplines = valeurListe(production.classification, "disciplines");
  const image = production.medias.find((media) =>
    ["AFFICHE", "VISUEL_HORIZONTAL", "PHOTO"].includes(media.type)
  );
  return (
    <article className="production-card">
      <Link to={`/productions/${production.id}`} className="production-card__visual">
        {image ? (
          <img src={image.miniature_url || image.url} alt="" loading="lazy" />
        ) : (
          <span className="production-card__monogramme" aria-hidden="true">
            {production.titre.slice(0, 2).toUpperCase()}
          </span>
        )}
        <span className="production-card__statut">{production.statut.replaceAll("_", " ")}</span>
      </Link>
      <div className="production-card__contenu">
        <OrigineBadge origine={production.origine} />
        <h3>
          <Link to={`/productions/${production.id}`}>{production.titre}</Link>
        </h3>
        <p className="production-card__compagnie">
          {production.compagnie || "Compagnie à découvrir"}
        </p>
        <p>{production.resume_court}</p>
        <div className="etiquettes">
          {disciplines.slice(0, 3).map((discipline) => (
            <span key={discipline}>{discipline}</span>
          ))}
        </div>
      </div>
    </article>
  );
}
